import { useMemo } from 'react';
import { extractVariableLabels, extractVariableLabelsFromDelta, isSystemVariable, normalizeVariableLabel } from "../TemplateVariables.utils";
export function useTemplateVariableDetection(textFields, richTextFields) {
  return useMemo(() => {
    const seen = new Set();
    const detectedVariables = [];
    for (const text of textFields) {
      for (const label of extractVariableLabels(text)) {
        const normalized = normalizeVariableLabel(label);
        if (!seen.has(normalized)) {
          seen.add(normalized);
          detectedVariables.push(label);
        }
      }
    }
    for (const richText of richTextFields) {
      for (const label of extractVariableLabelsFromDelta(richText)) {
        const normalized = normalizeVariableLabel(label);
        if (!seen.has(normalized)) {
          seen.add(normalized);
          detectedVariables.push(label);
        }
      }
    }
    const systemVariables = [];
    const customVariables = [];
    for (const label of detectedVariables) {
      if (isSystemVariable(label)) {
        systemVariables.push(label);
      } else {
        customVariables.push(label);
      }
    }
    return {
      detectedVariables,
      customVariables,
      systemVariables
    };
  }, [textFields, richTextFields]);
}